/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { matchPath } from 'react-router';
import { RouterStates } from '../definitions/RouterStates';
import { history } from '../customHistory';

export const isNotaryPortal = (currentRoute: string) => {
  if (
    matchPath(currentRoute, { path: RouterStates.JOURNAL, exact: true }) ||
    matchPath(currentRoute, { path: RouterStates.ROOM_ASSIGNMENTS, exact: true }) ||
    matchPath(currentRoute, { path: RouterStates.ROOMS, exact: true }) ||
    matchPath(currentRoute, { path: RouterStates.NOTARY_ROOM, exact: true }) ||
    matchPath(currentRoute, { path: RouterStates.INVITE, exact: true })
  ) {
    return true;
  }
  return false;
};

export const isNotaryRoute = (currentRoute: string) => !!matchPath(currentRoute, RouterStates.NOTARY);

export const isSigningRoute = (currentRoute: string) => {
  if (
    matchPath(currentRoute, RouterStates.ROOM) ||
    matchPath(currentRoute, RouterStates.NOTARY_SIGNING_ROOM) ||
    matchPath(currentRoute, RouterStates.PARTICIPANT_SIGNING_ROOM)
  ) {
    return true;
  }
  return false;
};

export const isNotarySigningRoute = (currentRoute: string) =>
  Boolean(matchPath(currentRoute, RouterStates.NOTARY_SIGNING_ROOM));

export const isSigningRoomRoute = (currentRoute: string) => {
  if (
    matchPath(currentRoute, RouterStates.NOTARY_SIGNING_ROOM) ||
    matchPath(currentRoute, RouterStates.PARTICIPANT_SIGNING_ROOM)
  ) {
    return true;
  }
  return false;
};

export const isDocumentPageRoute = (currentRoute: string) => {
  if (matchPath(currentRoute, RouterStates.DOCUMENT_MANAGEMENT)) {
    return true;
  }
  return false;
};

export const isOnboardingRoute = (currentRoute: string) => Boolean(matchPath(currentRoute, RouterStates.ROOM));

export const goTo = (path: string, pathParamsMap?: Record<string, string>) => {
  if (!!pathParamsMap) {
    Object.keys(pathParamsMap).forEach(key => {
      const value = pathParamsMap[key];
      path = path.replace(`/:${key}`, `/${value}`);
    });
  }
  history.push({ pathname: path });
};

export const openRoomInNewWindow = (roomId: string) => {
  window.open(`/notary/rooms/${roomId}`);
};

export const openSigningSession = (roomId: string) => {
  window.open(`/notary/rooms/${roomId}/signing`);
};

export const openJournalEntry = (baseJournalEntryId: string) => {
  window.open(`/notary/journal/${baseJournalEntryId}`);
};

/**
 * If you want to redirect to a react-router route, use gotTo() function rather than this function.
 * */
export const redirectToURL = (absoluteUrl: string) => {
  window.location.href = absoluteUrl;
};
